import React, { FC } from "react";
import { default as RcPagination, PaginationProps } from "rc-pagination";
import "./index.scss";
import { useStore } from "effector-react";
import { $currentLocale } from "../../store/shared/locales";

interface Props extends PaginationProps {
  disabled?: boolean;
}

const Pagination: FC<Props> = ({ disabled, ...props }) => {
  const { rcPaginationLocale: locale } = useStore($currentLocale);

  return (
    <RcPagination
      {...props}
      style={disabled ? { opacity: 0.5, ...props.style } : props.style}
      onChange={!disabled ? props.onChange : undefined}
      locale={locale}
    />
  );
};

export default Pagination;
